export type DiscoveryResult = {
  host: string
  rtsp_urls?: string[]
  onvif_urls?: string[]
}

export type CreateCameraRequest = {
  name: string
  location: string
  rtsp_url: string
  onvif_url: string
  username: string
  password: string
}

type CameraRecord = Record<string, string>

async function readError(response: Response, fallback: string) {
  const payload = await response.json() as { error?: string }
  return payload.error ?? fallback
}

export async function discoverCameras(target: string) {
  const response = await fetch('/api/cameras/discover', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ target }) })
  const payload = await response.json() as DiscoveryResult[] | { error?: string }
  if (!response.ok) throw new Error('error' in payload ? payload.error : 'Camera scan failed')
  if (!Array.isArray(payload)) throw new Error('Camera scan returned invalid data')
  return payload
}

export async function createCamera(camera: CreateCameraRequest) {
  const response = await fetch('/api/cameras', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(camera) })
  if (!response.ok) throw new Error(await readError(response, 'Camera could not be added'))
  return response.json() as Promise<CameraRecord>
}

export async function loadCameras() {
  const response = await fetch('/api/cameras')
  if (!response.ok) throw new Error('Camera list unavailable')
  return response.json() as Promise<CameraRecord[]>
}

export async function removeCamera(id: string) {
  const response = await fetch(`/api/cameras/${id}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Camera could not be removed')
}

export function cameraStreamURL(id: string) {
  return `/api/cameras/${id}/stream`
}
